<template>
  <v-flex
    xs12
    sm8
    lg6
  >
    <v-card class="pa-4">
      <div>
        <h3 class="headline mb-0">Sign In</h3>
        <div>Please enter your registered Email &amp; Password</div>
      </div>

      <v-form
        v-model="valid"
        class="mt-5"
        ref="form"
      >
        <v-text-field
          required
          clearable
          v-model="email"
          :rules="emailRules"
          label="E-mail"
          autocomplete="current-password"
        ></v-text-field>
        <v-text-field
          required
          clearable
          v-model="password"
          :rules="passwordRules"
          label="Password"
          type="password"
          autocomplete="current-password"
        ></v-text-field>

        <v-btn
          :disabled="!valid"
          color="accent"
          @click="submit "
        >Sign In</v-btn>
      </v-form>
    </v-card>
  </v-flex>
</template>


<script>
export default {
  data: () => ({
    valid: false,
    password: "",
    passwordRules: [
      v => !!v || "Password is required",
      v => v.length > 4 || "Password must be more than 4 characters"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid"
    ]
  }),

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  watch: {
    user(stateUser) {
      if (stateUser !== null) {
        this.$router.push("/");
      }
    }
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        const user = { email: this.email, password: this.password };
        this.$store.dispatch("signin", user);
        this.valid = false;
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/SignInPage.vue